export const PRINT_LAYOUT_STORAGE_KEY = "booking_v4_print_layout_settings";

export const DEFAULT_PRINT_LAYOUT_SETTINGS = {
  companyName: "KUBER BALI ADVENTURE",
  companyAddress: "Br. Bayad, Desa Melinggih Kelod, Payangan, Gianyar, Bali 80572",
  footerText: "Thank you for choosing our service!",
  logoDataUrl: "",
  paperWidth: 58,
  headerFontSize: 10,
  companyFontSize: 8,
  titleFontSize: 16,
  footerFontSize: 8,
  lineHeight: 1.1,
  rowGap: 3,
  charsPerLine: 32,
  characterSpacing: 0,
  printerFont: "font_c",
  fields: null,
  itemStyles: null,
};

// Ukuran kertas yang dipakai APK wrapper (GotraApp getPaperSize). null bila dibuka di browser biasa.
export const getWrapperPaperWidth = () => {
  if (typeof window === "undefined") return null;
  try {
    const paperSize = window.AndroidPrintHandler?.getPaperSize?.();
    if (paperSize === "80mm") return 80;
    if (paperSize === "58mm") return 58;
  } catch (error) {
    return null;
  }
  return null;
};

const clampNumber = (value, min, max, fallback) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return fallback;
  return Math.min(Math.max(number, min), max);
};

const normalizePrinterFont = (value) => {
  const aliases = {
    FontA: "font_a",
    FontB: "font_b",
    FontC: "font_c",
    fontA: "font_a",
    fontB: "font_b",
    fontC: "font_c",
  };
  const normalized = aliases[value] || value;
  return ["font_a", "font_b", "font_c"].includes(normalized)
    ? normalized
    : DEFAULT_PRINT_LAYOUT_SETTINGS.printerFont;
};

export const normalizePrintLayoutSettings = (settings = {}) => ({
  ...DEFAULT_PRINT_LAYOUT_SETTINGS,
  ...settings,
  paperWidth: Number(settings.paperWidth) >= 69 ? 80 : 58,
  headerFontSize: clampNumber(settings.headerFontSize, 6, 18, DEFAULT_PRINT_LAYOUT_SETTINGS.headerFontSize),
  companyFontSize: clampNumber(settings.companyFontSize, 6, 18, DEFAULT_PRINT_LAYOUT_SETTINGS.companyFontSize),
  titleFontSize: clampNumber(settings.titleFontSize, 6, 32, DEFAULT_PRINT_LAYOUT_SETTINGS.titleFontSize),
  footerFontSize: clampNumber(settings.footerFontSize, 6, 16, DEFAULT_PRINT_LAYOUT_SETTINGS.footerFontSize),
  lineHeight: clampNumber(
    settings.lineHeight ?? (0.7 + clampNumber(settings.rowGap, 0, 8, 3) * 0.1),
    0.5,
    3,
    DEFAULT_PRINT_LAYOUT_SETTINGS.lineHeight
  ),
  rowGap: clampNumber(settings.rowGap, 0, 8, DEFAULT_PRINT_LAYOUT_SETTINGS.rowGap),
  charsPerLine: clampNumber(settings.charsPerLine, 28, 42, DEFAULT_PRINT_LAYOUT_SETTINGS.charsPerLine),
  characterSpacing: clampNumber(settings.characterSpacing, 0, 4, DEFAULT_PRINT_LAYOUT_SETTINGS.characterSpacing),
  printerFont: normalizePrinterFont(settings.printerFont),
  companyName: String(settings.companyName || DEFAULT_PRINT_LAYOUT_SETTINGS.companyName).trim(),
  companyAddress: String(settings.companyAddress || DEFAULT_PRINT_LAYOUT_SETTINGS.companyAddress).trim(),
  footerText: String(settings.footerText || DEFAULT_PRINT_LAYOUT_SETTINGS.footerText).trim(),
  logoDataUrl: typeof settings.logoDataUrl === "string" ? settings.logoDataUrl : "",
  fields: Array.isArray(settings.fields) ? settings.fields : DEFAULT_PRINT_LAYOUT_SETTINGS.fields,
  itemStyles: Array.isArray(settings.itemStyles) ? settings.itemStyles : DEFAULT_PRINT_LAYOUT_SETTINGS.itemStyles,
});

export const getStoredPrintLayoutSettings = () => {
  if (typeof window === "undefined") return DEFAULT_PRINT_LAYOUT_SETTINGS;

  try {
    const stored = window.localStorage.getItem(PRINT_LAYOUT_STORAGE_KEY);
    if (!stored) return DEFAULT_PRINT_LAYOUT_SETTINGS;
    return normalizePrintLayoutSettings(JSON.parse(stored));
  } catch (error) {
    return DEFAULT_PRINT_LAYOUT_SETTINGS;
  }
};

export const savePrintLayoutSettings = (settings) => {
  const normalized = normalizePrintLayoutSettings(settings);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(PRINT_LAYOUT_STORAGE_KEY, JSON.stringify(normalized));
  }
  return normalized;
};
